export default __webpack_public_path__ + "static/media/arbic.4331b869.jpg";